/**
 * customsirge_product_body.js
 * PDP body interactions: scroll-to-top CTA, in-view Vimeo autoplay for video carousel.
 */
(function () {
  function initScrollTop() {
    document.querySelectorAll('[data-customsirge-scroll-top]').forEach(function (btn) {
      if (btn.dataset.customsirgeScrollTopBound) return;
      btn.dataset.customsirgeScrollTopBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  function buildVimeoSrc(id) {
    return (
      'https://player.vimeo.com/video/' +
      id +
      '?background=1&autoplay=1&loop=1&muted=1&autopause=0&playsinline=1'
    );
  }

  function initVideoAutoplay() {
    var frames = document.querySelectorAll('[data-customsirge-pdp-video-frame]');
    if (!frames.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var wrap = entry.target;
          var iframe = wrap.querySelector('iframe');
          var videoId = wrap.getAttribute('data-vimeo-id');
          if (!videoId) return;

          if (entry.isIntersecting) {
            if (!iframe) {
              iframe = document.createElement('iframe');
              iframe.setAttribute('src', buildVimeoSrc(videoId));
              iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
              iframe.setAttribute('title', 'Athlete video');
              wrap.appendChild(iframe);
            }
            wrap.classList.add('is-playing');
          } else if (iframe) {
            iframe.remove();
            wrap.classList.remove('is-playing');
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.35 }
    );

    frames.forEach(function (frame) {
      observer.observe(frame);
    });
  }

  function initHeroThumbGrid() {
    if (!document.body.classList.contains('template-productfeatured-product')) return;

    var nav = document.querySelector('#product-slider-nav');
    var mainSlider = document.querySelector('#product-slider');
    if (!nav || !mainSlider) return;

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      var mainSwiper = window.sliders && window.sliders['product-slider'];

      if (mainSwiper || attempts > 60) {
        clearInterval(timer);
      }

      if (!mainSwiper) return;

      if (window.productSliderNav && typeof window.productSliderNav.destroy === 'function') {
        window.productSliderNav.destroy(true, true);
        window.productSliderNav = null;
      }

      var wrapper = nav.querySelector('.swiper-wrapper');
      if (wrapper) {
        wrapper.style.transform = 'none';
      }

      var slides = nav.querySelectorAll('.swiper-slide');
      slides.forEach(function (slide, index) {
        if (index >= 4) {
          slide.style.display = 'none';
          return;
        }

        slide.addEventListener('click', function () {
          mainSwiper.slideTo(index);
          slides.forEach(function (s, i) {
            if (i < 4) s.classList.toggle('swiper-slide-thumb-active', i === index);
          });
        });
      });

      var activeIndex = typeof mainSwiper.activeIndex === 'number' ? mainSwiper.activeIndex : 0;
      slides.forEach(function (slide, index) {
        if (index < 4) slide.classList.toggle('swiper-slide-thumb-active', index === activeIndex);
      });

      if (!mainSwiper.__customsirgeThumbSync) {
        mainSwiper.__customsirgeThumbSync = true;
        mainSwiper.on('slideChange', function () {
          var idx = mainSwiper.activeIndex;
          slides.forEach(function (slide, i) {
            if (i < 4) slide.classList.toggle('swiper-slide-thumb-active', i === idx);
          });
        });
      }
    }, 150);
  }

  function init() {
    initScrollTop();
    initVideoAutoplay();
    initHeroThumbGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();